import React from 'react';
import { InputText, type InputTextProps } from 'primereact/inputtext';
import classNames from 'classnames';

interface IMyInputTextProps extends InputTextProps {
  label: string;
  className?: string;
  inputClassName?: string;
}

export default function MyInputText({
  label,
  className,
  inputClassName,
  ...props
}: IMyInputTextProps) {
  return (
    <div className={classNames('relative flex flex-col', className)}>
      <label className="flex absolute ml-4 mt-[-0.75rem] px-1 text-base rounded-lg bg-neutral-100">
        {label}
      </label>
      <InputText {...props} className={classNames('py-5', inputClassName)} />

      {props.maxLength && (
        <div className="self-end mt-2 text-sm">
          {props.value?.length ?? 0}/{props.maxLength}
        </div>
      )}
    </div>
  );
}
